import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { editPollRequested } from 'features/polls/actions';

export function* editPollSaga(action: ReturnType<typeof editPollRequested>) {
  yield call(SignalingSocket.send, { event: 'editPoll', data: action.payload });
}
